import { useState } from 'react';
import { IonModal, IonButton, IonText, IonIcon } from '@ionic/react';
import { close, warningOutline } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { CleanHTML } from '../../../defines/Functions';
import { Accordion, AccordionSection } from 'react-rainbow-components';
import Loading from '../../Loading';
import axios from 'axios';
import './FlightRules.css';

interface Props {
    data: any,
    flightDefines: any
}

const FlightRules = (item: Props) => {
    const [state, setState] = useState({
        showFlightRulesModal: false,
        flightCancelRulesData: [] as any,
        loading: false,
        errorMessage: ''
    })
    const flightRulesApi = Constants.api.flightsRules;
    const flightCancelRules = async () => {
        setState({ ...state, loading: true, showFlightRulesModal: true });
        try {
            let CorrelationID = item.data.ticketingInfo.ticketingVendor.codeContext;
            let companyShortName = item.data.ticketingInfo.ticketingVendor.companyShortName;
            let Target = item.data.ticketingInfo.ticketingVendor.code;
            let FilingAirline = item.data.airItineraryPricingInfo.validatingAirlineCode;
            if (FilingAirline === undefined || FilingAirline === null) {
                FilingAirline = '';
            } else {
                FilingAirline = '<FilingAirline Code="' + FilingAirline + '" />';
            }
            let xmlData = '<OTA_AirRuleRQ Target="' + Target + '" TargetName="' + companyShortName + '" CorrelationID="' + CorrelationID + '"><RuleReqInfo>';
            let airports = '';
            let dates = '';
            let farerefs = '';
            let marketingairlines = '';
            let cnt = 0;
            item.data.airItinerary.originDestinationOptions.originDestinationOption.forEach((OriginDestinationOption: any) => {
                OriginDestinationOption.flightSegment.forEach((FlightSegment: any) => {
                    let marketing_airline_code = '';
                    let fareBasisCode = '';
                    if (FlightSegment.fareBasisCode !== undefined) {
                        fareBasisCode = FlightSegment.fareBasisCode;
                    }
                    if (FlightSegment.marketingAirline.code !== undefined) {
                        marketing_airline_code = FlightSegment.marketingAirline.code;
                    }
                    airports += '<Airport CodeContext="' + cnt + '" LocationCode="' + FlightSegment.departureAirport.locationCode + ',' + FlightSegment.arrivalAirport.locationCode + '" />';
                    dates += '<Date Date="' + FlightSegment.departureDateTime + '" Type="' + cnt + '" />';
                    farerefs += '<FareInfo FareBasisCode="' + fareBasisCode + '" RPH="' + cnt + '" />';
                    marketingairlines += '<MarketingAirline Code="' + marketing_airline_code + '" CodeContext="' + cnt + '" />';
                    cnt++;
                });
            });
            xmlData += airports + dates + farerefs + marketingairlines + FilingAirline + '</RuleReqInfo></OTA_AirRuleRQ>';
            const results = await axios.post(flightRulesApi, xmlData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (results.data.items.hasOwnProperty('errors')) {
                setState({ ...state, showFlightRulesModal: true, flightCancelRulesData: [], errorMessage: results.data.items.errors.error[0].value });
                return;
            } else {
                setState({ ...state, showFlightRulesModal: true, flightCancelRulesData: results.data.items.fareRuleResponseInfo, loading: false });
            }

        } catch (error) {
            console.log(error);
            setState({ ...state, showFlightRulesModal: true, flightCancelRulesData: [], loading: false, errorMessage: '' });
        }
    }
    const openModal = () => {
        flightCancelRules();
    }
    return (
        <>
            <IonModal isOpen={state.showFlightRulesModal} onDidDismiss={() => setState({ ...state, showFlightRulesModal: false })} mode="ios" cssClass="flight-rules-modal">
                <div className="flight-rules-modal-content">
                    <h3 className="flight-rules-modal-title">
                        {item.flightDefines.targetName === 'Domestic' ?
                            'قوانین کنسلی'
                            :
                            'قوانین پرواز'
                        }
                        <IonIcon icon={close} onClick={() => setState({ ...state, showFlightRulesModal: false })} />
                    </h3>
                    {state.errorMessage.trim() !== '' ? (
                        <b className="no-result-text">
                            <IonIcon icon={warningOutline} />
                            {state.errorMessage}
                        </b>
                    ) : state.loading ? (
                        <Loading />
                    ) : (
                        [state.flightCancelRulesData.map((rule: any, index: number) =>
                            <div className="flight-rules-modal-items ion-padding" key={'index' + index}>
                                <h6 className="ion-no-margin ion-margin-bottom">قوانین ایرلاین مسیر {index + 1}</h6>
                                <Accordion className="flight-rules-accordion">
                                    {rule.fareRules.subSection.map((desc: any, descIndex: number) =>
                                        <AccordionSection label={!desc.subTitle ? 'xxx' : desc.subTitle} key={descIndex}>
                                            {desc.paragraph.map((paraf: any, parafIndex: number) =>
                                                <p key={parafIndex}>
                                                    {CleanHTML(paraf.text)}
                                                </p>
                                            )}
                                        </AccordionSection>
                                    )}
                                </Accordion>
                            </div>
                        )]
                    )}
                </div>
                <div className="flight-rules-modal-footer-btns">
                    <IonButton color="warning" onClick={() => setState({ ...state, showFlightRulesModal: false })} className="flight-rules-modal-close-btn">
                        بستن
                    </IonButton>
                </div>
            </IonModal>
            <IonText className="flight-rules-label" onClick={openModal}>
                {item.flightDefines.targetName === 'International' ?
                    'قوانین پرواز'
                    :
                    'قوانین کنسلی'
                }
            </IonText>
        </>
    );
};
export default FlightRules;